import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Dashbar from './Dashbar';
import BoardApps from './BoardApps';
import Loadash from './Loadash';
import NoBoards from './NoBoards';
import CreateBoard from './CreateBoard';
import BlankBoard from './BlankBoard';
import Footer from './Footer';

import { boards } from '../actions';
import TailorBanner from './TailorBanner';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      edit: false,
      boardTitle: '',
      boardId: null,
      boards: [],
    };
  }
  componentDidMount() {
    this.props.resetBoards();
    this.props.fetchBoards();
    window.analytics.page("View Dashboard");
  }
  trackApp = () => {
    
  }
  editBoard = () => {
    this.setState({ edit: true });
    
  }
  handleTitle = e => {
    e.preventDefault();
    this.setState({ boardTitle: e.target.value });
  }

  saveBoard = () => {
    this.setState({ edit: false });
    this.props.editBoard(this.state.boardId, this.state.boardTitle);
  }

  render() {
    const isLoading = this.state.isLoading;

    if (isLoading) {
      return(
        <div>
          <Dashbar/>
          <Loadash/>
        </div>
      );
    }
    if (this.props.boards.length < 1) {
      return(
        <div>
          <Dashbar />
          <NoBoards />
          <Footer />
        </div>
      );
    } else {
      return(
        <div>
          <Dashbar/>
          <div className="grid">
            {this.props.boards.map(board => (
              <div className="board" key={board.id}>
                <div className="category">
                  <h2>
                  {board.title}
                    {/*this.state.edit ? <input type="text" id="board-title" name="boardtitle" defaultValue={board.title} onChange={this.handleTitle} /> : board.title*/}
                    {this.state.edit ? <button className='btn alt' onClick={this.saveBoard}>Save</button> : <button className='btn alt' onClick={this.editBoard}>Edit</button>}
                    <Link to='/browse' className="btn add">Add</Link>
                    {this.state.edit ? <button className='btn alt delete' onClick={() => this.props.deleteBoard(board.id)}>Delete <span className="hide-mobile">Board</span></button> : null }
                  </h2>
                </div>
                {board.apps.length ?
                  <div>
                    {board.apps.map(app =>
                      <li key={app.id} onClick={this.trackApp}>
                        <BoardApps icon={app.icon} url={app.url} app_url={app.app_url} title={app.title} />      
                      </li>
                    )}
  
                  </div>
                :
                <BlankBoard />
                }
              </div>
            ))}
          </div>
          <Footer />
        </div>
      );
      
    }
    
  }
}

const mapStateToProps = state => {
  return {
    boards: state.boards,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchBoards: () => {
      dispatch(boards.fetchBoards());
    },
    resetBoards: () => {
      dispatch(boards.resetBoards());
    },
    editBoard: (boardId) => {
      dispatch(boards.editBoard(boardId));
    },
    deleteBoard: (boardId) => {
      dispatch(boards.deleteBoard(boardId));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.js